"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    staticClass: "modal-new-application",
    attrs: {
      active: true,
      width: 598,
      scroll: "keep",
      "can-cancel": ["escape"],
      "on-cancel": _vm.cancelModal
    }
  }, [_c("div", {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "card-content"
  }, [_c("div", {
    staticClass: "media"
  }, [_c("div", {
    staticClass: "media-content"
  }, [_c("button", {
    staticClass: "btn-x-close",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.cancelModal
    }
  }, [_c("i", {
    staticClass: "icon-ic_close"
  })]), _vm._v(" "), _c("p", {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])])]), _vm._v(" "), _c("div", {
    staticClass: "content"
  }, [_c("form", [_c("b-field", {
    attrs: {
      label: "Prescrição"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione uma prescrição",
      required: "",
      expanded: ""
    },
    model: {
      value: _vm.form.prescricaoId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "prescricaoId", $$v);
      },
      expression: "form.prescricaoId"
    }
  }, [_c("option", {
    attrs: {
      value: ""
    }
  }, [_vm._v("\n                Selecionar\n              ")]), _vm._v(" "), _vm._l(_vm.prescricoesDisponiveis, function (prescricao) {
    return _c("option", {
      key: prescricao.id,
      domProps: {
        value: prescricao.id
      }
    }, [_vm._v("\n                " + _vm._s(prescricao.name) + "\n              ")]);
  })], 2)], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Descrição (opcional)"
    }
  }, [_c("b-input", {
    attrs: {
      type: "textarea",
      placeholder: "Descreva detalhes sobre a aplicação",
      rows: "3"
    },
    model: {
      value: _vm.form.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao", $$v);
      },
      expression: "form.descricao"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Data de aplicação"
    }
  }, [_c("b-datepicker", {
    attrs: {
      placeholder: "Selecione a data",
      icon: "calendar-today",
      "date-formatter": _vm.formatDatePicker,
      required: ""
    },
    model: {
      value: _vm.form.dataAplicacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dataAplicacao", $$v);
      },
      expression: "form.dataAplicacao"
    }
  })], 1), _vm._v(" "), _c("div", [_c("label", {
    staticClass: "label"
  }, [_vm._v("Setores")]), _vm._v(" "), _c("div", _vm._l(_vm.form.setores, function (setor, index) {
    return _c("div", {
      key: index,
      staticClass: "sector-item"
    }, [_c("b-field", {
      staticClass: "sector-fields",
      attrs: {
        grouped: ""
      }
    }, [_c("b-field", {
      attrs: {
        label: "Setor",
        expanded: ""
      }
    }, [_c("b-select", {
      attrs: {
        placeholder: "Selecione um setor",
        expanded: ""
      },
      model: {
        value: setor.setorId,
        callback: function callback($$v) {
          _vm.$set(setor, "setorId", $$v);
        },
        expression: "setor.setorId"
      }
    }, [_c("option", {
      attrs: {
        value: ""
      }
    }, [_vm._v("\n                        Selecionar setor\n                      ")]), _vm._v(" "), _vm._l(_vm.setoresDisponiveis, function (s) {
      return _c("option", {
        key: s.id,
        domProps: {
          value: s.id
        }
      }, [_vm._v("\n                        " + _vm._s(s.name) + "\n                      ")]);
    })], 2)], 1), _vm._v(" "), _c("b-field", [_c("b-button", {
      staticClass: "remove-sector-btn",
      attrs: {
        type: "is-danger",
        "icon-left": "delete",
        disabled: _vm.form.setores.length === 1
      },
      on: {
        click: function click($event) {
          return _vm.removeSetor(index);
        }
      }
    })], 1)], 1)], 1);
  }), 0), _vm._v(" "), _c("b-button", {
    staticClass: "add-sector-btn",
    attrs: {
      type: "is-light",
      "icon-left": "plus"
    },
    on: {
      click: _vm.addSetor
    }
  }, [_vm._v("\n              Adicionar setor\n            ")])], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Equipamento"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione um equipamento",
      expanded: ""
    },
    model: {
      value: _vm.form.equipamentoId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "equipamentoId", $$v);
      },
      expression: "form.equipamentoId"
    }
  }, [_c("option", {
    attrs: {
      value: ""
    }
  }, [_vm._v("\n                Selecionar\n              ")]), _vm._v(" "), _vm._l(_vm.equipamentosDisponiveis, function (equipamento) {
    return _c("option", {
      key: equipamento.id,
      domProps: {
        value: equipamento.id
      }
    }, [_vm._v("\n                " + _vm._s(equipamento.name) + " - " + _vm._s(equipamento.type) + "\n              ")]);
  })], 2)], 1), _vm._v(" "), _c("b-field", {
    staticClass: "row-save-form"
  }, [_c("b-button", {
    staticClass: "btn-save-form",
    on: {
      click: _vm.save
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isEdit ? "Gravar" : "Criar") + "\n            ")])], 1)], 1)])])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;